import { useEffect } from 'react';
import type { ConnectDragPreview } from 'react-dnd';
import { getEmptyImage } from 'react-dnd-html5-backend';

export const useEmptyPreview = (preview: ConnectDragPreview): void => {
  useEffect(() => {
    preview(getEmptyImage(), { captureDraggingState: true });
  }, [preview]);
};
